<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div
        v-if="activeLoading"
        class="w-full h-full fixed block top-0 left-0 bg-white opacity-75 z-50"
      >
        <span
          class="text-green-500 opacity-75 top-1/2 my-0 mx-auto block relative w-0 h-0"
          style="
          top: 50%;"
        >
          <i class="fas fa-circle-notch fa-spin fa-5x"></i><br />
          <p class="text-sm text-blue-700 mt-2">
            Document is being prepared for signature
          </p>
        </span>
      </div>

      <div class="marginTop">
        <v-row class="mt-2 p-4 bg-light" style="border-radius: 2px;">
          <v-col cols="12" class="shadow" style="border-radius: 5px;" md="12">
            <v-toolbar color="primary" class="top-hero6" dark flat>
              <v-toolbar-title>Clients</v-toolbar-title>
            </v-toolbar>

            <div v-if="colorCode" class="text-center py-4 lg:px-4">
              <div
                class="p-2 bg-green-700 items-center text-gray-50 leading-none lg:rounded-full flex lg:inline-flex"
                role="alert"
              >
                <span
                  class="flex rounded-full bg-orange-100 uppercase px-2 py-1 text-xs text-green-700 font-bold mr-3"
                  >Status</span
                >
                <span class="font-semibold mr-2 text-left flex-auto"
                  >Ready for Send Signature</span
                >
                <svg
                  class="fill-current opacity-75 h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"
                  />
                </svg>
              </div>
            </div>
            <!--
                <div v-if="pending != ''" class="text-center py-4 lg:px-4">
                  <div class="p-2 bg-orange-700 items-center text-gray-50 leading-none lg:rounded-full flex lg:inline-flex" role="alert">
                    <span class="flex rounded-full bg-green-100 uppercase px-2 py-1 text-xs text-orange-700 font-bold mr-3">Status</span>
                    <span class="font-semibold mr-2 text-left flex-auto">Awaiting Signature</span>
                    <svg class="fill-current opacity-75 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"/></svg>
                  </div>
                </div> -->

            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Type
                    </th>
                    <th class="text-left">
                      Name
                    </th>
                    <th class="text-left">
                      Email
                    </th>

                    <th class="text-left">
                      Showings
                    </th>

                    <th class="text-left">
                      Status
                    </th>

                    <th class="text-left">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :class="
                      setColor(client.email) || pendingColor(client.email)
                    "
                    v-for="client in clients"
                    :key="client.id"
                  >
                    <td>
                      <span
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-base bg-blue-100 text-blue-800"
                        >{{ client.type }}</span
                      >
                    </td>
                    <td>{{ client.name }}</td>
                    <td
                      :class="
                        changeColor(client.id)
                          ? 'bg-green-100 text-green-800 font-medium'
                          : ''
                      "
                    >
                      {{ client.email }}
                    </td>

                    <td>
                      <v-btn
                        v-if="hasRequested(client.searches)"
                        @click="openShowing(client.searches)"
                        x-small
                        color="secondary"
                      >
                        Requested Showings
                      </v-btn>
                    </td>

                    <td>
                      <div v-for="track in client.trackers" :key="track.id">
                        <template v-if="track.status === 'request_signature'">
                          <small class="font-bold">
                            {{ track.menu_name }}:
                          </small>
                          <span
                            @click="
                              openClient(client, track.submission, track.id)
                            "
                            class="mt-1 cursor-pointer inline-flex items-center text-xs px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-600"
                          >
                            {{ track.status.replace("_", " ") }}
                            <i class="fas fa-signature ml-1"></i>
                          </span>
                        </template>

                        <template
                          class="mt-1"
                          v-else-if="track.status === 'email_sent'"
                        >
                          <small class="font-bold">
                            {{ track.menu_name }}:
                          </small>
                          <span
                            @click="openClient(client, track.submission)"
                            class="mt-3 cursor-pointer inline-flex items-center text-xs px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-600"
                          >
                            {{ track.status.replace("_", " ") }}
                          </span>
                          <span class="text-xs">Already Signed? click</span>
                          <v-btn
                            x-small
                            :disabled="track.status == 'signed'"
                            @click="isSigned(track)"
                            color="success"
                            class="ml-1"
                          >
                            <span
                              class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"
                            ></span>
                            HERE
                          </v-btn>
                        </template>

                        <template
                          class="mt-1"
                          v-else-if="track.status === 'signed'"
                        >
                          <small class="font-bold">
                            {{ track.menu_name }}:
                          </small>
                          <span
                            @click="
                              openClient(client, track.submission, false, track)
                            "
                            class="mt-1 cursor-pointer inline-flex items-center text-xs px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-600"
                          >
                            {{ track.status }}
                          </span>
                        </template>
                      </div>
                    </td>

                    <td>
                      <v-btn
                        x-small
                        rounded
                        text
                        :loading="showLoading"
                        @click="resendEmail(client)"
                      >
                        Reset Password</v-btn
                      >

                      <v-btn
                        x-small
                        rounded
                        class="ml-2"
                        color="#2196F3"
                        @click="openClient(client)"
                        dark
                      >
                        View Client</v-btn
                      >
                      <v-btn
                        @click="removeClient(client)"
                        x-small
                        rounded
                        class="ml-2"
                        color="#E53935"
                        dark
                      >
                        Delete</v-btn
                      >
                      <template v-if="client.source != '1'">
                        <v-btn
                          v-if="!validMessage"
                          color="success"
                          x-small
                          rounded
                          class="ml-2"
                          :disabled="loadingShow"
                          @click="verifyUser(client)"
                        >
                          Move to HM</v-btn
                        >
                        <template v-else-if="errorMessage">
                          <v-alert
                            border="top"
                            colored-border
                            type="info"
                            elevation="2"
                          >
                            User Already exist.
                          </v-alert>
                        </template>

                        <v-btn
                          :disabled="loadingShow"
                          class="ml-2"
                          x-small
                          v-else
                          rounded
                          color="secondary"
                          @click="createClient(client)"
                          dark
                        >
                          Create User in HM
                        </v-btn>
                        <v-icon
                          color="red"
                          v-if="validMessage"
                          @click="validMessage = !validMessage"
                          >mdi-minus</v-icon
                        >
                      </template>
                      <template v-else>
                        <v-chip class="ml-2">Successfully Moved</v-chip>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card tile style="background-color: #F5F5F5;">
        <v-toolbar flat dark color="#01579B">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-divider></v-divider>
          <v-list three-line subheader>
            <v-subheader>Requested Showings</v-subheader>
          </v-list>

          <v-row>
            <div
              class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg-grid-cols-4 xl:grid-cols-4"
            >
              <div v-for="showing in filterShowings" :key="showing.id">
                <single-card
                  :rental="showing"
                  :isSearch="true"
                  :markShown="true"
                  @marked="markShownHome(showing)"
                  @canceled="requestCanceled(showing)"
                ></single-card>
              </div>
            </div>
          </v-row>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import SingleCard from "../SingleCard/SingleCard.vue";
import { mapGetters } from "vuex";
import moment from "moment";
import flatpickr from "flatpickr";
import Swal from "sweetalert2";
export default {
  components: { SingleCard },
  data() {
    return {
      showLoading: false,
      loadingShow: false,
      showAlert: true,
      newName: "",
      newEmail: "",
      newName2: "",
      newEmail2: "",

      isOpenTag: false,
      activeLoading: false,
      hideSig: true,
      hiddeButton: true,
      dialog: false,
      checkbox1: false,
      notes: "",
      url: process.env.VUE_APP_API_URL_FILES,

      clients: [],
      validMessage: false,
      errorMessage: false,
      singleClient: false,

      submission: "",
      valid: true,
      roleName: "",
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length <= 15) || "Name must be less than 15 characters"
      ],

      showings: "",
      selectedTime: ""
    };
  },

  mounted() {
    window.Echo.channel("get-client").listen("ClientStatus", () => {
      this.$store.dispatch("getUser");
      this.getClients();
    });
  },

  computed: {
    filterShowings() {
      return this.showings.filter(showing => {
        return showing.request_showing == 1;
      });
    },

    ...mapGetters({
      user: "userLogin"
    }),

    colorCode() {
      return localStorage.code;
    },

    pending() {
      return localStorage.pending;
    }
  },

  created() {
    this.getClients();
  },

  methods: {
    hasRequested(searches) {
      if (searches) {
        return searches.some(value => value.request_showing == "1");
      } else {
        return false;
      }
    },

    markShownHome(showing) {
      window.axios.post("/api/updateShowing/" + showing.id).then(() => {
        this.dialog = false;
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Succesfully marked as shown",
          showConfirmButton: false,
          timer: 1500
        });
        this.getClients();
      });
    },

    requestCanceled(showing) {
      window.axios.post("/api/showingCancel/" + showing.id).then(() => {
        this.dialog = false;
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Succesfully requested shown canceled",
          showConfirmButton: false,
          timer: 1500
        });
        this.getClients();
      });
    },

    openShowing(showings) {
      this.showings = showings;
      this.dialog = true;
    },

    isSigned(track) {
      let flatpickrInstance;
      Swal.fire({
        title: "Please select notify date-time",
        footer: "This will send a text message to the client",
        html: '<input class="swal2-input" id="expiry-date">',
        stopKeydownPropagation: false,
        preConfirm: () => {
          if (flatpickrInstance.selectedDates[0] < new Date()) {
            Swal.showValidationMessage(
              `The departure date can't be in the past`
            );
          }
        },
        didOpen: () => {
          flatpickrInstance = flatpickr(
            Swal.getPopup().querySelector("#expiry-date"),
            {
              enableTime: true,
              minTime: "09:00",
              maxTime: "17:00",
              dateFormat: "Y-m-d H:i"
            }
          );
        },
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, confirm!"
      }).then(result => {
        if (result.isConfirmed) {
          window.axios
            .post("/api/updateStatus/" + track.id, {
              selectedTime: flatpickrInstance.selectedDates[0]
            })
            .then(() => {
              this.getClients();
              Swal.fire("Done!", "Successfully updated.", "success");
            });
        }
      });
    },

    checkStatus(client) {
      console.log(this.user);
      console.log(client);
    },

    formatDate(date) {
      let newDate = moment.utc(date).format("MMMM Do YYYY");
      return (this.dataModal = newDate);
    },

    setColor(value) {
      if (localStorage.email == value) {
        return "bg-green-100 text-green-800 font-medium";
      }
    },

    pendingColor(value) {
      if (localStorage.pending == value) {
        return "bg-orange-100 text-orange-800 font-medium";
      }
    },

    changeColor(value) {
      this.user.notifications.forEach(noti => {
        if (noti.data.newSignature) {
          if (noti.data.newSignature.user_id == value) {
            return true;
          }
        }
      });
    },

    addSignature(user, id) {
      this.dialog = false;
      this.activeLoading = true;
      let code = this.$route.query.code;
      window.axios
        .post("/api/addSignature/" + id, {
          clientName: user.name,
          clientEmail: user.email,
          newCode: code,
          newName: this.newName,
          newEmail: this.newEmail,
          newName2: this.newName2,
          newEmail2: this.newEmail2
        })
        .then(res => {
          console.log(res.data);
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Submission waiting for signature",
            showConfirmButton: false,
            timer: 1500
          });
          localStorage.setItem("pending", user.email);
          this.newName = "";
          this.newEmail = "";
          this.newName2 = "";
          this.newEmail2 = "";
          localStorage.removeItem("email");
          localStorage.removeItem("code");
          this.getClients();
          this.activeLoading = false;
          window.location.href = "https://www.homesby360.com/manage/clients";
        });
    },

    generateCode(email) {
      this.dialog = false;
      this.activeLoading = true;
      localStorage.setItem("email", email);
      localStorage.setItem("code", true);
      window.location.href =
        process.env.VUE_APP_ACCOUNT_BASE_URL +
        "?response_type=code&scope=signature&client_id=" +
        process.env.VUE_APP_ACCOUNT_ID +
        "&redirect_uri=" +
        process.env.VUE_APP_ACCOUNT_URI;
    },

    createSubmission(submission) {
      var queryString = $("#myFormAdmin input:text").serializeArray(); // store json object

      $("#myFormAdmin input:checkbox").each(function(i, e) {
        queryString.push({
          name: e.name,
          value: e.checked ? "Yes" : "Off",
          box: true
        });
      });

      window.axios
        .post("/api/updateSubmissionAdmin/" + submission.id, {
          queryString: queryString,
          notes: this.notes
        })
        .then(() => {
          this.dialog = false;
          this.submission = "";
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Form data succesfully sent, Waiting for aprove",
            showConfirmButton: false,
            timer: 1500
          });
          this.getClients();
        });
    },

    verifyUser(user) {
      this.loadingShow = true;
      window.axios
        .post("/api/verifyClient", {
          email: user.email
        })
        .then(res => {
          if (res.data === "message") {
            this.loadingShow = false;
            return (this.validMessage = !this.validMessage);
          } else if (res.data === "error") {
            return (this.errorMessage = !this.errorMessage);
          } else {
            console.log(res.data);
          }
        });
    },

    removeClient(client) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.isConfirmed) {
          window.axios.patch("/api/removeClient/" + client.id).then(() => {
            this.getClients();
            Swal.fire("Deleted!", "User successfully deleted.", "success");
          });
        }
      });
    },

    resendEmail(client) {
      Swal.fire({
        title: "Are you sure?",
        text: "This action will send a email to the client with the reset link",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, send it!"
      }).then(result => {
        if (result.isConfirmed) {
          this.showLoading = true;
          window.axios
            .post("api/adminPassReset", { email: client.email })
            .then(() => {
              this.getClients();
              this.showLoading = false;
              Swal.fire("Sent!", "Email successfully sent", "success");
            });
        }
      });
    },

    createClient(user) {
      this.loadingShow = true;
      window.axios
        .post("/api/makeClient", {
          user: user
        })
        .then(res => {
          this.loadingShow = false;
          if (res.data === "error") {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text:
                "Something went wrong! Please refresh the page and try again",
              footer: "If problem persist contact VQV Support"
            });
          } else if (res.data === "exists") {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text:
                "A client with this email address already exists in HomeManager",
              footer: "If problem persist contact VQV Support"
            });
          } else if (res.data === "Data Successfully sent") {
            this.getClients();
            this.validMessage = false;
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Client successfully sent to Home Manager",
              showConfirmButton: false,
              timer: 1500
            });
          }
        });
    },

    // createRole() {
    //   window.axios
    //     .post("/api/createRoles", {
    //       name: this.roleName
    //     })
    //     .then(() => {
    //       this.getRoles();
    //     });
    // },

    // getRoles() {
    //   window.axios.get("/api/getRoles").then(response => {
    //     this.roles = response.data;
    //   });
    // },

    openSubmission(submission) {
      this.submission = submission;
      this.dialog = true;
      // $("#submision").modal("show");
    },

    // openClient(client) {
    //   this.validMessage = false;
    //   this.errorMessage = false;
    //   this.singleClient = !this.singleClient;
    //   this.user = client;
    // },
    openClient(client, sub, track, status) {
      this.$router.push({
        name: "Dashboard",
        params: {
          user: client,
          code: this.$route.query.code,
          submission: sub,
          trackId: track,
          status: status
        }
      });
      // window.axios.get("/api/viewClient/" + client.id).then(response => {
      //   console.log(response.data);
      //   this.$router.push({name: "Dashboard"})
      // });
    },

    getClients() {
      window.axios.get("/api/users").then(response => {
        this.clients = response.data;
      });
    },

    updateSubmission(submission) {
      var queryString = $("#myFormId").serializeArray(); // store json object

      window.axios
        .post("/api/updateSubmissionAdmin/" + submission.id, {
          queryString: queryString
        })
        .then(() => {
          console.log("repos");
        });
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Quicksand:400,500,700&subset=latin-ext");

.wrapper {
  width: 100%;
  width: 100%;
  height: auto;
  padding: 50px 20px;
  padding-top: 100px;
  background-image: linear-gradient(-20deg, #defffd 0%, #eeeeee 100%);

  @media screen and (max-width: 768px) {
    height: auto;
    min-height: 100vh;
    padding-top: 100px;
  }
}

.profile-card {
  width: 100%;
  min-height: 460px;
  margin: auto;
  background: #fff;
  border-radius: 12px;
  max-width: 700px;
  position: relative;

  &.active {
    .profile-card__cnt {
      filter: blur(6px);
    }

    .profile-card-message,
    .profile-card__overlay {
      opacity: 1;
      pointer-events: auto;
      transition-delay: 0.1s;
    }

    .profile-card-form {
      transform: none;
      transition-delay: 0.1s;
    }
  }

  &__img {
    width: 150px;
    height: 150px;
    margin-left: auto;
    margin-right: auto;
    transform: translateY(-50%);
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    z-index: 4;
    box-shadow: 0px 5px 50px 0px rgb(108, 68, 252),
      0px 0px 0px 7px rgba(107, 74, 255, 0.5);

    @media screen and (max-width: 576px) {
      width: 120px;
      height: 120px;
    }
  }
  #myFormId {
    text-align: left;
  }

  &__cnt {
    margin-top: -35px;
    text-align: center;
    padding: 0 20px;
    padding-bottom: 40px;
    transition: all 0.3s;
  }

  &__name {
    font-weight: 700;
    font-size: 24px;
    color: #6944ff;
    margin-bottom: 15px;
  }

  &__txt {
    font-size: 18px;
    font-weight: 500;
    color: #324e63;
    margin-bottom: 15px;

    strong {
      //color: #ff2846;
      font-weight: 700;
    }
  }

  &-inf {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-top: 35px;

    &__item {
      padding: 10px 35px;
      min-width: 150px;

      @media screen and (max-width: 768px) {
        padding: 10px 20px;
        min-width: 120px;
      }
    }

    &__title {
      font-weight: 700;
      font-size: 27px;
      //color: #6944ff;
      color: #324e63;
    }

    &__txt {
      font-weight: 500;
      margin-top: 7px;
    }
  }

  &-ctr {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;

    @media screen and (max-width: 576px) {
      flex-wrap: wrap;
    }
  }

  &__button {
    background: none;
    border: none;
    font-family: "Quicksand", sans-serif;
    font-weight: 700;
    font-size: 19px;
    margin: 5px;
    padding: 15px 40px;
    min-width: 201px;
    border-radius: 50px;
    min-height: 55px;
    color: #fff;
    cursor: pointer;
    backface-visibility: hidden;
    transition: all 0.3s;

    @media screen and (max-width: 768px) {
      min-width: 170px;
      margin: 15px 25px;
    }

    @media screen and (max-width: 576px) {
      min-width: inherit;
      margin: 0;
      margin-bottom: 16px;
      width: 100%;
      max-width: 300px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &:focus {
      outline: none !important;
    }

    @media screen and (min-width: 768px) {
      &:hover {
        transform: translateY(-5px);
      }
    }

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    &.button--blue {
      background: linear-gradient(45deg, #1da1f2, #0e71c8);
      box-shadow: 0px 4px 30px rgba(19, 127, 212, 0.4);

      &:hover {
        box-shadow: 0px 7px 30px rgba(19, 127, 212, 0.75);
      }
    }

    &.button--green {
      background: linear-gradient(45deg, #02a225, #146304);

      &:hover {
        box-shadow: 0px 7px 30px rgba(4, 79, 26, 0.75);
      }
    }

    &.button--orange {
      background: linear-gradient(45deg, #d5135a, #f05924);
      box-shadow: 0px 4px 30px rgba(223, 45, 70, 0.35);

      &:hover {
        box-shadow: 0px 7px 30px rgba(223, 45, 70, 0.75);
      }
    }

    &.button--silver {
      background: linear-gradient(45deg, #2e2e2e, #aeaeae);
      box-shadow: 0px 4px 30px rgba(109, 109, 109, 0.35);

      &:hover {
        box-shadow: 0px 7px 30px rgba(39, 39, 39, 0.75);
      }
    }

    &.button--gray {
      box-shadow: none;
      background: #dcdcdc;
      color: #142029;
    }
  }
}
</style>
